import styled from 'styled-components';
import { ButtonRoot, getButtonSizesMixin, buttonSizes } from '@salutejs/plasma-core';
import { bodySBold, bodyLBold, bodyMBold } from '@salutejs/plasma-typo';
import { buttonViews } from '../../Button.props';
var buttonTypography = {
  l: bodyLBold,
  m: bodyMBold,
  s: bodySBold
};
var applySizes = /*#__PURE__*/getButtonSizesMixin(buttonSizes, buttonTypography);
export var ButtonB2C = /*#__PURE__*/styled(ButtonRoot).withConfig({
  componentId: "plasma-web-core__sc-dz1nyk-0"
})(["", " ", ""], applySizes, function (_ref) {
  var view = _ref.view;
  return buttonViews[view];
});